import { render, staticRenderFns } from "./indexBusiness.vue?vue&type=template&id=0a86f5b9&scoped=true"
import script from "./indexBusiness.vue?vue&type=script&lang=js"
export * from "./indexBusiness.vue?vue&type=script&lang=js"
import style0 from "./indexBusiness.vue?vue&type=style&index=0&id=0a86f5b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a86f5b9",
  null
  
)

export default component.exports